import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";

import SoftBox from "components/SoftBox";
import MiniCard from "examples/Cards/MiniCard";

import { useAuth } from "context/AuthContext";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function UserDashboard() {
  const { isSuperAdmin, isAdmin, isUser, isStaff, isManager } = useAuth();

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {isSuperAdmin ? <SuperAdminDashboard /> :
       isAdmin ? <AdminDashboard /> :
       isManager ? <ManagerDashboard /> :
       isStaff ? <StaffDashboard /> :
       isUser ? <TenantDashboard /> :
       null}

      <Footer />
    </DashboardLayout>
  );
}

export default UserDashboard;

function DashboardCards({ cards, prefix }) {
  const navigate = useNavigate();

  const handleLinkClick = (url) => {
    navigate(`/${prefix}/${url}`);
  };

  return (
    <SoftBox py={3}>
      <Grid container spacing={3}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} xl={4} key={index}>
            <MiniCard
              title={card.title}
              links={card.links}
              icon={card.icon}
              onLinkClick={handleLinkClick}
            />
          </Grid>
        ))}
      </Grid>
    </SoftBox>
  );
}

DashboardCards.propTypes = {
  cards: PropTypes.array.isRequired,
  prefix: PropTypes.string.isRequired,
};

function SuperAdminDashboard() {
  const cards = [
    {
      title: "Organization",
      icon: "business",
      links: [
        { url: "organization", text: "Organizations" },
        { url: "organization/create", text: "Create Organization" },
      ],
    },
  ];

  return <DashboardCards cards={cards} prefix="super-admin" />;
}

function AdminDashboard() {
  const cards = [
    {
      title: "Properties",
      icon: "home",
      links: [
        { url: "properties", text: "Properties" },
        { url: "access-control", text: "Access Control" },
      ],
    },
  ];

  return <DashboardCards cards={cards} prefix="admin" />;
}

function ManagerDashboard() {
  const cards = [
    {
      title: "Properties",
      icon: "apartment",
      links: [{ url: "properties", text: "Properties" }],
    },
  ];

  return <DashboardCards cards={cards} prefix="manager" />;
}

function StaffDashboard() {
  const cards = [
    {
      title: "Front Desk",
      icon: "desk",
      links: [
        { url: "event/log", text: "Event Log" },
        { url: "instructions", text: "Instructions" },
        { url: "incident/reports", text: "Incident Reports" },
      ],
    },
    {
      title: "Residents",
      icon: "groups",
      links: [
        { url: "resident/directory", text: "Resident Directory" },
      ],
    },
  ];

  return <DashboardCards cards={cards} prefix="concierge" />;
}

function TenantDashboard() {
  const cards = [
    {
      title: "Dashboard",
      icon: "home",
      links: [
        { url: "sitemap", text: "Site Map" },
        { url: "profile", text: "My Profile" },
        { url: "local-link", text: "Local Links" },
      ],
    },
    {
      title: "Manage",
      icon: "account_circle",
      links: [
        { url: "calendar", text: "Calendar" },
        { url: "library", text: "Library" },
        { url: "reservations", text: "Reservations" },
      ],
    },
    {
      title: "Maintenance",
      icon: "engineering",
      links: [
        { url: "maintenance/new/request", text: "New Request" },
        { url: "maintenance/search/requests", text: "Search Requests" },
      ],
    },
  ];

  return <DashboardCards cards={cards} prefix="user" />;
}